import React, {useEffect, useState, FormEvent, useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {
  fetchSelectedArticle,
  fetchUpdateSelectedArticle,
  resetSelectedArticle,
  fetchArticles,
} from '../../reducer/article-reducer';
import {connect} from 'react-redux';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Container,
} from 'reactstrap';
import {FormattedMessage, useIntl} from 'react-intl';
import Etiquetas from '../../components/etiquetas';
import Fuentes from '../../components/fuentes';
import Moment from 'react-moment';
import {articulo, tagFront, sources} from '../../types/general-types';
import {Store} from 'react-notifications-component';
import RichTextEditor from 'react-rte';
import {
  createArticle,
  publishArticle,
  unPublishArticle,
} from '../../api/articles';
import {useNavigate} from 'react-router-dom';
import ImageUploader from '../../components/imageUploader';
import '../../sass/article.scss';
import {v4 as uuidv4} from 'uuid';
import Select from 'react-select';
interface configObject {
  user: {
    token: string;
  };
  articles: {
    selectedArticle: articulo;
  };
  configReducer: {
    siteConfig: {
      languages: {id: string; language: string}[] | null;
    };
  };
}
interface propiedades {
  token: string | null;
  selectedArticle: articulo;
  fetchSelectedArticle: (id: string, token: string) => void;
  fetchUpdateSelectedArticle: any;
  resetSelectedArticle: any;
  editor?: boolean;
  fetchArticles: (token: string | null) => void;
  languages: {id: string; language: string}[] | null;
}

const Articulo = (props: propiedades) => {
  const {
    fetchSelectedArticle,
    token,
    selectedArticle,
    fetchUpdateSelectedArticle,
    editor,
    resetSelectedArticle,
    fetchArticles,
    languages,
  } = props;
  const {id: urlId} = useParams<{id?: string}>();
  const id = useMemo(() => {
    return urlId || uuidv4();
  }, [urlId]);

  const format = 'markdown';
  const intl = useIntl();
  const navigate = useNavigate();
  const [title, setTitle] = useState<string>('');
  const [introduction, setIntroduction] = useState(
    RichTextEditor.createEmptyValue(),
  );
  const [content, setContent] = useState(RichTextEditor.createEmptyValue());
  const [fuentes, setFuentes] = useState<sources[]>([]);
  const [tags, setTags] = useState<tagFront[]>([]);
  const [articuloActualizado, setArticuloActualizado] =
    useState<Boolean>(false);
  const [versionAnterior, setVersionAnterior] = useState({});
  const [pictureUrl, setPictureUrl] = useState<string | undefined>(undefined);
  const [selectedOption, setSelectedOption] = useState<
    {value: string; label: string} | {value: string; label: string}[] | null
  >(null);

  const options: any = [];
  if (languages) {
    languages.forEach((lang) => {
      options.push({value: lang.id, label: lang.language});
    });
  }

  const [selectedPushOption, setSelectedPushOption] = useState<
    | {value: 'NONE'; label: string}
    | {value: 'ALL'; label: string}
    | {value: 'TAG'; label: string}
  >({value: 'NONE', label: 'No Enviar'});

  const pushOptions = [
    {value: 'NONE', label: 'No Enviar'},
    {value: 'ALL', label: 'A todos los Usuarios'},
    {value: 'TAG', label: 'Solo Usuarios con etiquetas'},
  ] as const;

  useEffect(() => {
    if (token && editor) {
      fetchSelectedArticle(id, token);
    }
  }, [fetchSelectedArticle, id, token, editor]);

  useEffect(() => {
    if (selectedArticle && editor) {
      setTitle(selectedArticle.title);
      setIntroduction(
        RichTextEditor.createValueFromString(selectedArticle.brief, format),
      );
      setContent(
        RichTextEditor.createValueFromString(selectedArticle.content, format),
      );
      const tagsTransformed = JSON.parse(
        JSON.stringify(selectedArticle.tags)
          .split('"description":')
          .join('"text":'),
      );
      setTags(tagsTransformed);
      setFuentes(selectedArticle.sources);
      setVersionAnterior(selectedArticle);
      setPictureUrl(selectedArticle.pictureUrl);
      if (languages) {
        const opcionesSeleccionadas: {value: string; label: string}[] | null =
          [];
        languages.forEach((lang) => {
          selectedArticle.languages.forEach((s_a_lang) => {
            if (lang.language === s_a_lang) {
              opcionesSeleccionadas.push({
                value: lang.id,
                label: lang.language,
              });
            }
          });
        });
        if (opcionesSeleccionadas.length) {
          setSelectedOption(opcionesSeleccionadas);
        } else {
          setSelectedOption(null);
        }
      }
    }
    if (
      selectedArticle &&
      selectedArticle !== versionAnterior &&
      articuloActualizado
    ) {
      Store.addNotification({
        title: 'Excelente',
        message: 'Los cambios se aplicaron con éxito',
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }
  }, [
    selectedArticle,
    articuloActualizado,
    versionAnterior,
    editor,
    resetSelectedArticle,
    languages,
  ]);

  useEffect(() => {
    if (!editor) {
      resetSelectedArticle();
      setTitle('');
      setIntroduction(RichTextEditor.createEmptyValue());
      setContent(RichTextEditor.createEmptyValue());
      setFuentes([{description: '', href: ''}]);
      setTags([]);
      setArticuloActualizado(false);
      setVersionAnterior({});
      setPictureUrl(undefined);
      setSelectedOption(null);
    }
  }, [editor, resetSelectedArticle]);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    const tagsTransformed = JSON.parse(
      JSON.stringify(tags).split('"text":').join('"description":'),
    );
    event.preventDefault();
    const languages: string[] = [];
    if (Array.isArray(selectedOption)) {
      selectedOption.forEach((lang) => {
        languages.push(lang.label);
      });
    } else if (selectedOption) {
      languages.push(selectedOption.label);
    }
    const articuloModificado: articulo = {
      title: title,
      content: content.toString(format),
      brief: introduction.toString(format),
      tags: tagsTransformed,
      sources: fuentes,
      pictureUrl: selectedArticle?.pictureUrl,
      createdAt: selectedArticle?.createdAt,
      createdBy: selectedArticle?.createdBy,
      publishedAt: selectedArticle?.publishedAt,
      languages: languages,
      notification: selectedPushOption.value,
    };

    if (editor) {
      fetchUpdateSelectedArticle(id!, token, articuloModificado).then(() => {
        fetchArticles(token);
      });
    } else {
      createArticle(token, articuloModificado, id).then((res) => {
        fetchArticles(token);
        navigate('/admin/listar-articulos');
      });
    }
    setArticuloActualizado(true);
  }

  const handlePublishUnpublish = async () => {
    let res: string | {data: {id: string}};
    if (selectedArticle?.publishedAt) {
      res = await unPublishArticle(id!, token);
    } else {
      res = await publishArticle(id!, token);
    }
    if (typeof res === 'object' && res.data?.id === id) {
      fetchArticles(token);
      navigate('/admin/listar-articulos');
    }
  };

  return (
    <Container>
      <Row>
        <Form onSubmit={handleSubmit} className="mt-4 mb-4">
          <FormGroup>
            <Input
              innerRef={(input) => {
                if (input) {
                  input.classList.remove('form-control');
                }
              }}
              type="text"
              name="title"
              id="title"
              value={title}
              className="w-100 h1 p-2"
              onChange={(event) => setTitle(event.target.value)}
              placeholder={intl.formatMessage({id: 'title'})}
            />
          </FormGroup>
          <Row>
            <Col className="d-flex justify-content-between">
              {selectedArticle?.createdAt && (
                <div>
                  <FormattedMessage
                    id="created_at"
                    defaultMessage="created_at"
                  />
                  <Moment format="DD/MM/YYYY">
                    {selectedArticle.createdAt}
                  </Moment>
                </div>
              )}
              {selectedArticle?.publishedAt && (
                <div>
                  <FormattedMessage
                    id="published_at"
                    defaultMessage="published_at"
                  />
                  <Moment format="DD/MM/YYYY">
                    {selectedArticle.publishedAt}
                  </Moment>
                </div>
              )}
              {selectedArticle?.createdBy && (
                <div>
                  <FormattedMessage
                    id="created_by"
                    defaultMessage="created_by"
                  />
                  :<span> {selectedArticle.createdBy.email}</span>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <ImageUploader
                articleId={id!}
                imageSrc={pictureUrl}
                onImageChange={setPictureUrl}
                errorMessage={undefined}
              />
            </Col>
          </Row>
          <FormGroup>
            <Label className="h2">
              <FormattedMessage id="brief" defaultMessage="brief" />
            </Label>
            <RichTextEditor
              value={introduction}
              onChange={(value) => setIntroduction(value)}
            />
          </FormGroup>
          <FormGroup>
            <Label className="h2">
              <FormattedMessage id="content" defaultMessage="content" />
            </Label>
            <RichTextEditor
              value={content}
              onChange={(value) => setContent(value)}
            />
          </FormGroup>
          <FormGroup>
            <Label className="h2">Idioma</Label>
            <Select
              value={selectedOption}
              placeholder="Seleccione un idioma"
              onChange={(newValue) => setSelectedOption(Array.from(newValue))}
              options={options}
              isMulti={true}
            />
          </FormGroup>
          <Fuentes fuentes={fuentes} setFuentes={setFuentes} />
          <FormGroup>
            <Label className="h2">Notificacion Push</Label>
            <Select
              value={selectedPushOption}
              onChange={(newValue) =>
                setSelectedPushOption(newValue ?? pushOptions[0])
              }
              options={pushOptions}
            />
          </FormGroup>
          <Row>
            <Col className="mb-2 mt-4">
              <Etiquetas tags={tags} setEtiquetas={setTags} />
            </Col>
          </Row>
          <Button type="submit" className="w-100 background-primary border-0">
            {editor ? (
              <FormattedMessage id="update" defaultMessage="update" />
            ) : (
              'Guardar'
            )}
          </Button>
          <Button
            onClick={handlePublishUnpublish}
            className="w-100 background-primary border-0 mt-2"
            disabled={!editor}
          >
            {selectedArticle?.publishedAt ? 'Despublicar' : 'Publicar '}
          </Button>
        </Form>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    selectedArticle: state.articles.selectedArticle,
    languages: state.configReducer.siteConfig.languages,
  };
};
export default connect(mapStateToProps, {
  fetchSelectedArticle,
  fetchUpdateSelectedArticle,
  resetSelectedArticle,
  fetchArticles,
})(Articulo);
